// Copyright 2015, EMC, Inc.

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Menu, Popover } from 'material-ui';

export default class ContextMenu extends Component {
  static propTypes = {
    menuList: PropTypes.array,
    openEvent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    onClose: PropTypes.func,
  };

  static defaultProps = {
    menuList: [],
    openEvent: null,
    onClose: null,
  };

  componentDidMount() {
    this.openTimer = null;
  }

  componentWillReceiveProps(nextProps) {
    const nextState = {};
    if (nextProps.openEvent) {
      nextState.openEvent = {
        absX: nextProps.openEvent.absX,
        absY: nextProps.openEvent.absY,
      };

      this.openTimer = new Date().getTime();
    }
    if (nextProps.menuList) {
      nextState.menuList = nextProps.menuList;
    }

    this.setState(nextState, () => {
      if (nextState.openEvent && !this.state.open) {
        this.setState({ open: true });
      }
      if (!nextState.openEvent && this.state.open) {
        this.setState({ open: false });
      }
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  state = {
    open: !!this.props.openEvent,
    openEvent: this.props.openEvent,
    menuList: this.props.menuList,
  };

  get mockAnchorEl() {
    const openEvent = this.state.openEvent ||
      this.lastOpenEvent || { relX: 0, relY: 0 };
    this.lastOpenEvent = openEvent;
    let height = 8;
    height += 16;
    height += 48 + 8;
    height += 48 + 8;
    // this.state.menuList.forEach(menuItem => {
    //   if (menuItem === 'divider') {
    //     height += 16;
    //   } else {
    //     height += 48 + 8;
    //   }
    // });
    return {
      getBoundingClientRect: () => ({
        // bottom: 0,
        left: openEvent.absX,
        // right: 0,
        top: openEvent.absY,
      }),
      offsetWidth: 336,
      offsetHeight: height,
    };
  }

  closePopover() {
    const now = new Date().getTime();

    if (now - this.openTimer > 150) {
      this.setState({ open: false }, () => {
        this.setState({ openEvent: null }, this.props.onClose);
      });

      this.openTimer = null;
    }
  }

  render() {
    const mockAnchorEl = this.mockAnchorEl;

    const menu = (
      <Menu style={{ width: mockAnchorEl.offsetWidth }}>
        {this.state.menuList}
      </Menu>
    );

    return (
      <Popover
        style={{
          width: mockAnchorEl.offsetWidth + 2,
          height: mockAnchorEl.offsetHeight + 2,
          border: '1px solid white',
        }}
        open={this.state.open}
        anchorEl={mockAnchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        onRequestClose={() => {
          this.closePopover();
        }} // eslint-disable-line react/jsx-no-bind
        useLayerForClickAway={false}
      >
        {menu}
      </Popover>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ActivityTable/ContextMenu.js